import { memo } from "react";
import styled from "styled-components";
import { dividerColor, defaultColor } from "../../../helpers/color";
const Track = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Track",
  componentId: "sc-2ne4lo-0"
})(["position:relative;flex:1;& + &{flex:2;border-top:2px solid ", ";}"], dividerColor));
export default Track;
//# sourceMappingURL=Track.js.map